import { createRouter, createWebHashHistory } from "vue-router";
import LayoutMain from "../components/LayoutMain";

const routes = [
    {
        path: "/login",
        name: "Login",

        component: () =>
            import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
    },
    {
        path: "/register",
        name: "Register",

        component: () =>
            import(/* webpackChunkName: "Login" */ "../views/Register.vue"),
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",

        component: () =>
            import(
                /* webpackChunkName: "Login" */ "../views/ForgotPassword.vue"
            ),
    },
    {
        path: "/",
        component: LayoutMain,
        children: [
            {
                path: "/",
                name: "Home",
                component: () =>
                    import(/* webpackChunkName: "home" */ "../views/Home.vue"),
            },
            {
                path: "/about",
                name: "About",

                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../views/About.vue"
                    ),
            },
            {
                path: "request-appointment",
                name: "RequestAppointment",

                component: () =>
                    import(
                        /* webpackChunkName: "RequestAppointment" */ "../views/RequestAppointment.vue"
                    ),
            },
            {
                path: "scheduled-appointment",
                name: "ScheduledAppointment",

                component: () =>
                    import(
                        /* webpackChunkName: "ScheduledAppointment" */ "../views/ScheduledAppointment.vue"
                    ),
            },
            {
                path: "new-appointment",
                name: "NewAppointment",

                component: () =>
                    import(
                        /* webpackChunkName: "NewAppointment" */ "../views/NewAppointment.vue"
                    ),
            },
            {
                path: "messages/:id",
                name: "Messages",

                component: () =>
                    import(
                        /* webpackChunkName: "Messages" */ "../views/Messages.vue"
                    ),
            },
            {
                path: "compose-message",
                name: "ComposeMessage",

                component: () =>
                    import(
                        /* webpackChunkName: "RequestAppointment" */ "../views/ComposeMessage.vue"
                    ),
            },
        ],
        beforeEnter: (to, from, next) => {
            const user = localStorage.getItem("USER");

            if (user == null || user == undefined) {
                next({ name: "Login" });
            } else {
                next();
            }
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
